<template>
  <div style="padding-bottom: 2%;">
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <div class="col-12 col-md-9" style="padding-bottom: 2%;">
      <div class="invoiceBox">
        <p style="color: rgb(89, 149, 247); margin-top: 1%; margin-left: 2%; font-size: 11px;"> CURRENT BALANCE </p>
        <strong style="font-size: 28px; display: block; margin-top: 1%; margin-left: 2%;">${{currentBalance}}</strong>
        <p style="font-size: 14px; margin-left: 2%;">As of {{currDate}}</p>
        <div v-if="doneLoading == true" style="border: 0.5px solid rgb(89, 149, 247); width: 95%; margin-bottom: 1%; margin-left: 1%;" />
        <div v-if="doneLoading == true" class="col-10 col-md-12">
          <base-select v-model="form.naicsCode"
                       :options="dropdownValues.sectors"
                       :readonly="readonly"
                       :validation="$v.form.naicsCode"
                       v-on:input="updateTextField"
                       label="Please select the description that best fits your business">
          </base-select>
          <div v-if="form.naicsCode !== '' && form.naicsCode !== null">
            <br />
            <base-input v-model="form.naicsOther"
                         v-if="form.naicsCode === '00000'"
                         :validation="$v.form.naicsOther"
                         label="Please enter a description of your business">
            </base-input>
            <br />
            <base-input class="col-md-8"
                        v-model="form.totalEmployees"
                        :validation="$v.form.totalEmployees"
                        type="number"
                        min="0"
                        label="Please enter the number of employees at this facility location"></base-input>
            <base-input class="col-md-8"
                        v-model="form.facilitySqFootage"
                        :validation="$v.form.facilitySqFootage"
                        type="number"
                        min="0"
                        label="Please enter the total square footage of your facility"></base-input>
          </div>
          <base-select v-model="form.iepaPermit"
                       :options="form.iepaPermitOptions"
                       :readonly="readonly"
                       :validation="$v.form.iepaPermit"
                       label="Please select which IEPA permit you have, if applicable:">
          </base-select>
        </div>
        <div v-if="(form.iepaPermit !== 'N/A' && form.iepaPermit !== '' && form.iepaPermit !== 'ROSS')" class="col-10 col-md-12">
          <emissions-file-upload v-on:requestIdGenerated="updateFileRequestId" :siteNumber="siteNumber" />
          <br />
        </div>
        
        <div v-if="doneLoading == true" style="border: 0.5px solid rgb(89, 149, 247); width: 95%; margin-bottom: 1%; margin-left: 1%;" />
        <div class="eDetailElement" v-if="doneLoading == true">
          <p style="margin-top: 3%; font-size: 14px; max-width: 95%;">
            All Cook County Department of Environment and Sustainability Air division documents, including equipment registration permits and certificates of operation, will be sent electronically via email. A valid email address must be supplied in order to receive information regarding your application, including approved permits and certificates of operation.
          </p>
          <p style="margin-top: 1%; font-size: 14px;">
            Enter the email address to which all communications regarding application information should be addressed, and to which your documents should be sent.
          </p>
        </div>
        <div class="col-12 col-md-6 eDetailElement" v-if="doneLoading == true" style="margin-top: 1%;">
          <!--(form.level2Option != null && form.level2Option != '')-->
          <label class="required"> Payer Email </label>
          <base-input v-model="form.payerEmail"
                      :validation="$v.form.payerEmail">
          </base-input>
        </div>
        <div class="col-12 col-md-6 eDetailElement" v-if="doneLoading == true">
          <label class="required"> Verify Payer Email </label>
          <base-input v-model="form.payerEmailV"
                      :validation="$v.form.payerEmailV">
          </base-input>
        </div>

        <div class="col-12 col-md-12" style="margin-top: 2%;">
          <button class="btn btn-success eDetailElement" id="withCard" @click="payWithCreditCard">
            Pay with <strong> Credit Card </strong>
          </button>
        </div>
        <div class="col-12 col-md-12">
          <button class="btn btn-success eDetailElement" id="withACH" @click="payAchCheck">
            Pay with <strong> ACH Check*</strong>
          </button>
          <p style="display: inline; font-size: 14px;">
            If your financial institution requires a Company ID, the NEW Company/Provider ID is 0000408976.
            <i>(The current COMPANY ID may still be used until the change takes place)</i>
          </p>
        </div>
      </div>
     </div>
    <div class="col-12 col-md-3">
      <button class="btn btn-secondary eDetailElement" style="margin-left: 5%; margin-top: 13%;" @click="back('SiteInvoices')">
        Back to Invoices
      </button>
    </div>
    <form ref="lexisNexisForm" method="post" :action="lnLexisNexisPostUrl">
      <input type="hidden" name="ORDER_XML" v-model="orderXml" />
    </form>
</div>

</template>

<script>
  import { getInvoiceLexisNexisPaymentData, getSiteMasterBalance, getInvoicePayAchUrl, saveIepaPermit } from '~/js/FormFunctions'
  import BaseSelect from '@/components/BaseSelect'
  import BaseInput from '@/components/BaseInput'
  import { AirEmissionsValidations } from '@/js/FormValidations'
  import NaicsCodesDropdown from '~/js/NaicsCodesDropdown'
import EmissionsFileUpload from './EmissionsFileUpload.vue'

  export default {
    name: 'InvoiceCheckoutType',
    components: { BaseSelect, BaseInput, EmissionsFileUpload },

    data() {
      return {
        title: '2018 Invoice',
        currentBalance: 0,
        fetchingData: true,
        lnLexisNexisPostUrl: null,
        orderXml: null,
        currDate: null,
        form: this.$parent.$attrs.form,
        doneLoading: false,
        dropdownValues: new NaicsCodesDropdown(),
        fileRequestId: null,
        siteNumber: this.$parent.$parent.$attrs.siteNumber
      }
    },
    beforeMount() {
      this.currDate = this.formatDate()
    },
    mounted() {
      this.siteNumber = this.$parent.$parent.$attrs.siteNumber
      this.form.payerEmail = null
      this.form.payerEmailV = null
      this.form.iepaPermit = ''
      this.form.totalEmployees = null
      this.form.facilitySqFootage = null
      const vm = this
      getSiteMasterBalance(this.siteNumber)
        .then((data) => {
          vm.fetchingData = false
          vm.currentBalance = data.balance.toFixed(2)
          vm.doneLoading = true
        })
        .catch(() => {
          vm.fetchingData = false
        })
    },
    validations: {
      form: new AirEmissionsValidations()
    },
    methods: {
      back: function (name) {
        this.$router.push({ name: name, query: this.$route.query })
      },
      updateFileRequestId: function (requestId) {
        this.fileRequestId = requestId;
      },
      payAchCheck: function () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.$v.$touch()
          this.$notify('One or more required fields haven\'t been answered, please check the page and fill them in', 'error')
          return
        }
        this.fetchingData = true
        //TODO: add call to save data here
        if (this.form.iepaFileUploaded !== true && this.form.iepaPermit !== 'N/A' && this.form.iepaPermit !== '' && this.form.iepaPermit !== 'ROSS') {
          this.$notify('Please upload your emissions report to the portal.', 'error');
          this.fetchingData = false
          return;
        }
        saveIepaPermit(this.form, this.siteNumber)
        .then((data) => {})
        .catch((error) => {
          self.fetchingData = false
          errorNotification(error)
        })
        getInvoicePayAchUrl(this.siteNumber, this.form.payerEmail, this.fileRequestId)
          .then((data) => {
            window.location = data;
          })
          .catch((error) => {
            self.fetchingData = false
            errorNotification('Error submitting payment to vendor for ach:', error)
          })
      },
      updateTextField: function() {
        this.form.naicsDescription = this.dropdownValues.sectors.find(x => x.value === this.form.naicsCode).text;
      },
      payWithCreditCard: function () {
        this.$v.$touch()
        console.log(this.$v);
        if (this.$v.$invalid) {
          this.$v.$touch()
          this.$notify('One or more required fields haven\'t been answered, please check the page and fill them in', 'error')
          return
        }
        const self = this
        this.fetchingData = true
        //TODO: add call to save data here
        if (this.form.iepaFileUploaded !== true && this.form.iepaPermit !== 'N/A' && this.form.iepaPermit !== '' && this.form.iepaPermit !== 'ROSS') {
          this.$notify('Please upload your emissions report to the portal.', 'error');
          this.fetchingData = false
          return;
        }
        saveIepaPermit(this.form, this.siteNumber)
          .then((data) => {})
          .catch((error) => {
            self.fetchingData = false
            errorNotification(error)
          })
        getInvoiceLexisNexisPaymentData(this.siteNumber, this.form.payerEmail, this.fileRequestId)
          .then((data) => {
            self.lnLexisNexisPostUrl = `https://${data.paymentUrlBase}/oobML/il/co/cook/DES/`

            const orderXml = `<?xml version="1.0" encoding="utf-8"?>
            <multiLineFormPostRequest>
            <bypassReceiptUrl>${data.returnUrl}</bypassReceiptUrl>
            <lexisNexisCode>71527</lexisNexisCode>
            <paymentLineItems>
            <productLines>
            <productAmount>${data.totalFee}</productAmount>
            <lexisNexisProductCode>DES Online Payment</lexisNexisProductCode>
            <refField>${data.transactionId}</refField>
            <refField1>${data.sessionId}</refField1>
            </productLines>
            </paymentLineItems>
            </multiLineFormPostRequest>`
            self.$set(self, 'orderXml', orderXml)

            self.$nextTick(() => {
              self.$refs.lexisNexisForm.submit()
            })
          })
          .catch((error) => {
            self.fetchingData = false
            console.error(error)
          })
      }
    }
  }

</script>
